<template>
  <cos-modal
    v-model:visible="visible"
    :title="editForm.id ? t('btn.edit') : t('btn.add')"
    width="600px"
    @ok="handleSubmit"
    :confirmLoading="loading"
  >
    <a-form :model="editForm" ref="formRef" v-if="visible" autocomplete="off">
      <a-form-item
        name="cosId"
        :label="t('operate.ne6i7u')"
        :rules="[{ required: true, message: t('common.pleaseSelect') }]"
      >
        <CustomerSelect
          v-model:value="editForm.cosId"
          v-model:label="editForm.customerName"
          appId="cos_ofbu"
          @selectData="selectData"
          :disabled="editForm.id"
        />
      </a-form-item>
    </a-form>
  </cos-modal>
</template>
<script lang="ts">
import { ref } from 'vue'
import { customerLossCreate, updateBiLoseWarning } from '@/api/overseasSales/businessRuleSetting'
import type { FormInstance } from 'ant-design-vue'
import { AddBiLoseWarningParams } from '@/typings/api/overseasSales'
import { DcMessage } from '@dc-platform/dc-components'
import CustomerSelect from '@/components/ClueAndCustomerSelect/src/customer.vue'
import { useI18n } from 'vue-i18n'
export default { name: 'editModal' }
</script>
<script setup lang="ts">
const { t } = useI18n()
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref<FormInstance>()
const editForm = ref<AddBiLoseWarningParams>({})
const emit = defineEmits(['success'])
const toggle = (row?: AddBiLoseWarningParams) => {
  visible.value = !visible.value
  if (row && row.id) {
    editForm.value = { ...row }
  } else {
    editForm.value = {}
  }
}
const selectData = (value: string) => {
  editForm.value.arkCode = value
}
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const { arkCode, cosId, riskLevel } = editForm.value
    const p = {
      arkCode,
      cosId,

      riskLevel
    }
    try {
      if (editForm.value.id) {
        await updateBiLoseWarning({ ...p, id: editForm.value.id })
      } else {
        await customerLossCreate(p)
      }
      loading.value = false

      emit('success', editForm.value?.id ? 'edit' : 'add')
      DcMessage.success(editForm.value?.id ? t('operate.mmet2b') : t('operate.ywoekr'))
      toggle()
    } catch (error) {
      loading.value = false
    }
  })
}
defineExpose({
  toggle
})
</script>

<style lang="scss"></style>
